@file:OptIn(InternalResourceApi::class)

package ourdailyfinances.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ourdailyfinances.shared.generated.resources/"

@delegate:ResourceContentHash(362_120_138)
internal val Res.drawable.app_icon: DrawableResource by lazy {
      DrawableResource("drawable:app_icon", setOf(
        ResourceItem(setOf(), "${MD}drawable/app_icon.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(379_089_144)
internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

@delegate:ResourceContentHash(845_747_505)
internal val Res.drawable.hero_laptop: DrawableResource by lazy {
      DrawableResource("drawable:hero_laptop", setOf(
        ResourceItem(setOf(), "${MD}drawable/hero_laptop.png", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-390_471_026)
internal val Res.drawable.logo_mark: DrawableResource by lazy {
      DrawableResource("drawable:logo_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/logo_mark.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app_icon", Res.drawable.app_icon)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("hero_laptop", Res.drawable.hero_laptop)
  map.put("logo_mark", Res.drawable.logo_mark)
}
